import { EmptyState, FlexBox } from '@dixa/lib-shared-habla';

import styles from './teamTableEmptyState.module.scss';

type TeamTableEmptyStateProps = {
  onClearFilters: () => void;
};

export const TeamTableEmptyState = ({
  onClearFilters,
}: TeamTableEmptyStateProps) => {
  return (
    <FlexBox
      alignItems="center"
      justifyContent="center"
      className={styles.wrapper}
    >
      <EmptyState
        icon="search"
        title="No agents found"
        description="No agents match your current filters. Try adjusting or clearing your filters to see more results."
        buttonProps={{
          children: 'Clear filters',
          variant: 'secondary',
          onClick: onClearFilters,
          icon: 'close',
        }}
      />
    </FlexBox>
  );
};
